/**
 * File: FeatureCard.js
 * Origin: isotect
 * Description: [TODO: Description]
 *
 * Version: v1.1.0
 * Created: 2025-11-09
 * Last Updated: 2026-02-12
 *
 * Used By: isotect
 * Maintainer: Zachary Dicks
 *
 * Notes:
 * - Changes in this file may affect all consuming frontend modules.
 * - See Git repository 'isotect' for full change history.
 */

// Third-party packages
import { Link } from "react-router-dom";

/**
 * [TODO: Component description here]
 *
 * @param {Object} props - Component properties
 * @returns {JSX.Element} [TODO: Rendered output]
 */
function FeatureCard({ link, image, header, description, onClick }) {
    return (
        <>
            <Link className="feature-card" to={link} onClick={onClick}>
                <div className="feature-card__container">
                    <div className="feature-card__icon-container">
                        <img src={image} className="feature-card__icon"></img>
                    </div>
                    <div className="feature-card__headers">
                        <p className="feature-card__title">{header}</p>
                        <p>{description}</p>
                    </div>
                </div>
            </Link>
        </>
    );
}

export default FeatureCard;
